import React from 'react';
import { useDashboard } from '../../hooks/useDashboard';
import MetricCard from './MetricCard';
import VentasChart from './VentasChart';
import TopProductos from './TopProductos';
import StockCritico from './StockCritico';
import ConciliacionBancaria from './ConciliacionBancaria';
import Loading from '../common/Loading';
import ErrorMessage from '../common/ErrorMessage';
import '../../styles/Dashboard.css';

const Dashboard = () => {
  const { data, loading, error, refetch } = useDashboard();

  if (loading) {
    return <Loading fullScreen />;
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <ErrorMessage 
          message={error} 
          onRetry={refetch}
          type="error"
        />
      </div>
    );
  }

  // Estructura de datos del backend
  const {
    ventas_dia = 0,
    ventas_mes = 0,
    ticket_promedio = 0,
    top_productos = [],
    stock_critico = 0,
    productos_criticos = [],
    total_ventas = 0,
    total_banco = 0,
    diferencia = 0,
    porcentaje_conciliado = 0,
    ventas_por_dia = [],
    ventas_por_farmacia = [],
    fecha_actualizacion = null
  } = data || {};

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Dashboard</h1>
        <div className="dashboard-header-actions">
          {fecha_actualizacion && (
            <span className="last-update">
              Última actualización: {new Date(fecha_actualizacion).toLocaleTimeString()}
            </span>
          )}
          <button
            className="btn btn-primary btn-refresh"
            onClick={refetch}
            disabled={loading}
          >
            🔄 Actualizar
          </button>
        </div>
      </div>

      {/* Métricas principales */}
      <div className="metrics-grid">
        <MetricCard
          title="Ventas del Día"
          value={ventas_dia}
          icon="💰"
          type="currency"
          color="success"
        />
        <MetricCard
          title="Ventas del Mes"
          value={ventas_mes}
          icon="📈"
          type="currency"
          color="primary"
        />
        <MetricCard
          title="Ticket Promedio"
          value={ticket_promedio}
          icon="🎫"
          type="currency"
          color="info"
        />
        <MetricCard
          title="Stock Crítico"
          value={stock_critico}
          icon="⚠️"
          type="number"
          color="warning"
        />
      </div>

      {/* Gráfico de ventas */}
      <div className="dashboard-row">
        <div className="dashboard-col-full">
          <VentasChart
            data={ventas_por_dia}
            dataByFarmacia={ventas_por_farmacia}
            type="line"
            title="Ventas por Farmacia (Últimos 3 Meses)"
          />
        </div>
      </div>

      {/* Widgets secundarios */}
      <div className="dashboard-row">
        <div className="dashboard-col-half">
          <TopProductos productos={top_productos} />
        </div>
        <div className="dashboard-col-half">
          <StockCritico productos={productos_criticos} />
        </div>
      </div>

      {/* Conciliación bancaria */}
      <div className="dashboard-row">
        <div className="dashboard-col-full">
          <ConciliacionBancaria
            conciliacion={{
              total_ventas,
              total_banco,
              diferencia,
              porcentaje_conciliado
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

// Made with Bob
